
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TableSingleChip extends Vue {
  @Prop(String) readonly item!: string;
  @Prop(String) readonly chipClass!: string;
}
